<template>
    <div class="custom-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-button @click="saveRec" type="primary" size="mini"><i class="el-icon-setting"></i>&nbsp;保存</el-button>
            <el-button @click="exportInfo" type="primary" size="mini"><i class="el-icon-download"></i>&nbsp;导出</el-button>
            <el-button @click="printInfo" type="primary" size="mini"><i class="el-icon-printer"></i>&nbsp;打印</el-button>
        </div>

        <!-- 表格区域 -->
        <div class="reportInfo" :style="{height:reportInfoHeight+ 'px'}">
            <table class="reportInfoTable" cellpadding="0" cellspacing="0">
                <tr class="tableTitle">
                    <td class="textCenter" colspan="9">
                        {{ reportInfo.semesterName }}试卷质量分析报告
                    </td>
                </tr>
                <tr>
                    <td colspan="7" style="text-align: center;">
                        课程名称：{{ reportInfo.courseName }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        课程代码：{{ reportInfo.courseCode }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        课程性质：{{ reportInfo.courseProperty }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        学分：{{ reportInfo.credit }}
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">
                        任课教师：{{ reportInfo.teaName }}
                    </td>
                    <td class="tableBorder" colspan="4">
                        班级名称：{{ reportInfo.className }}
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder" colspan="3">
                        <div style="display: inline-block;">考核方式：</div>
                        <div style="display: inline-block;">
                            <el-select v-model="reportInfo.examTypeCode" placeholder="请选择考试形式" @change="handleExamTypeChange" style="width: 190px;" clearable>
                                <el-option v-for="(item, index) in comboOption.examType" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </div>
                    </td>
                    <td class="tableBorder" colspan="2">
                        <div style="display: inline-block;">考试日期：</div>
                        <div style="display: inline-block;">
                            <el-date-picker v-model="reportInfo.examDate" type="date" style="width: 200px;"
                                placeholder="请选择考试日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </td>
                    <td class="tableBorder" colspan="2">
                        人数：{{ reportInfo.statisticsInfo.stuNum }}
                    </td>
                </tr>
                <tr style="height:50px;">
                    <td class="tableBorder textCenter" rowspan="4" style="width: 40px;">
                        试<br/><br/>卷<br/><br/>成<br/><br/>绩
                    </td>
                    <td class="tableBorder textCenter" style="width: 100px;">
                        成绩等级
                    </td>
                    <td class="tableBorder textCenter" style="width: 150px;">
                        90 - 100<br/>（优秀）
                    </td>
                    <td class="tableBorder textCenter" style="width: 150px;">
                        80 - 89<br/>（良好）
                    </td>
                    <td class="tableBorder textCenter" style="width: 150px;">
                        70 - 79<br/>（中等）
                    </td>
                    <td class="tableBorder textCenter" style="width: 150px;">
                        60 - 69<br/>（及格）
                    </td>
                    <td class="tableBorder textCenter" style="width: 150px;">
                        &lt; 60<br/>（不及格）
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter">人数</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.firstLevelNum }}</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.secondLevelNum }}</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.thirdLevelNum }}</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.fourthLevelNum }}</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.fifthLevelNum }}</td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter">所占比例</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.firstLevelRatio }}%</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.secondLevelRatio }}%</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.thirdLevelRatio }}%</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.fourthLevelRatio }}%</td>
                    <td class="tableBorder textCenter">{{ reportInfo.statisticsInfo.fifthLevelRatio }}%</td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter">平均值</td>
                    <td class="tableBorder textCenter" colspan="2">
                        {{ reportInfo.statisticsInfo.avgScore }}
                    </td>
                    <td class="tableBorder textCenter">标准差</td>
                    <td class="tableBorder textCenter" colspan="2">
                        {{ reportInfo.statisticsInfo.standardDeviation }}
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter">
                        试<br/><br/>卷<br/><br/>情<br/><br/>况<br/><br/>分<br/><br/>析
                    </td>
                    <td class="tableBorder textCenter" colspan="6">
                        <div style="width:100%; height:270px;">
                            <simpleLineChart ref="simpleLineChart" :key="chartTimestamp" :chartData="chartData"
                                style="width:100%; height:270px;"/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="tableBorder textCenter">
                        改<br/><br/>进<br/><br/>措<br/><br/>施
                    </td>
                    <td class="tableBorder" colspan="6" style="padding:0;">
                        <el-input type="textarea"
                            placeholder="请填写改进措施,限500字以内"
                            v-model="reportInfo.improveMeasure"
                            :rows="8"
                            maxlength="500"
                            show-word-limit
                        >
                        </el-input>
                    </td>
                </tr>
                <tr style="height: 50px;">
                    <td class="tableBorder" colspan="3">系部主任（签字）：</td>
                    <td class="tableBorder" colspan="2">教研室主任（签字）：</td>
                    <td class="tableBorder" colspan="2">任课教师（签字）：</td>
                </tr>
                <tr>
                    <td colspan="7">
                        备注：此表连同试卷装订存放。
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import { globalConfig } from "static/config"
    import { confirmMsg, showNotify } from "utils/message";
    import simpleLineChart from "src/views/chart/simpleLineChart.vue";

    export default {
        components: {
            simpleLineChart,
        },
        props: {
            relatedCode: {
                type: String,
                default () {
                    return null;
                },
            },
            reportInfoHeight: {
                type: Number,
                default () {
                    return 840;
                },
            },
        },
        data() {
            return {
                queryForm: {
                    relatedCode: null,
                },
                comboOption: {
                    examType: null,
                },
                reportInfo: {
                    relatedCode: null,
                    semesterName: null,
                    courseName: null,
                    courseCode: null,
                    courseProperty: null,
                    credit: null,
                    teaName: null,
                    className: null,
                    examTypeCode: null,
                    examTypeName: null,
                    examDate: null,
                    statisticsInfo : {
                        stuNum: null,
                        firstLevelNum: null,
                        firstLevelRatio: null,
                        secondLevelNum: null,
                        secondLevelRatio: null,
                        thirdLevelNum: null,
                        thirdLevelRatio: null,
                        fourthLevelNum: null,
                        fourthLevelRatio: null,
                        fifthLevelNum: null,
                        fifthLevelRatio: null,
                        avgScore: null,
                        standardDeviation: null,
                        chartInfo: null,
                    },
                    chartImgData: null,
                    improveMeasure: null,
                },
                loadingMask: null,
                chartData: {
                    type: null,
                    mainTitle: null,
                    subtitle: null,
                    legend: null,
                    color: null,
                    xAxisName: null,
                    xAxisData: null,
                    yAxisName: null,
                    lineDatas: null,
                    tooltipType: null,
                    noDataTips: null,
                },
                chartTimestamp: '',
            }
        },
        mounted() {
            if(this.relatedCode){
                this.queryForm.relatedCode = this.relatedCode;
            }else{
                this.queryForm.relatedCode = this.$route.query.relatedCode;
            }
            if(this.$route.query.height) this.reportInfoHeight = this.$route.query.height;

            this.initCombo();
        },
        methods: {
            initCombo(){
                this.$api.scoreManage.statistics.examQualityAnalysis.initCombo({}).then((res) => {
                    this.comboOption.examType = res.data.data.examType;

                    this.queryInfo();
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });
            },
            queryInfo() {
                this.showLoadingMask("成绩登记表加载中，请稍候...");
                this.$api.scoreManage.statistics.examQualityAnalysis.query({
                    data: this.queryForm,
                }).then((res) => {
                    this.reportInfo = res.data.data;

                    // this.chartData.mainTitle = '综合分析';
                    // this.chartData.subTitle = row.questName;

                    if(this.reportInfo.statisticsInfo.chartInfo.lineDatas.length > 0) {
                        this.chartData.type = 'line';
                    } else {
                        this.chartData.type = 'noData';
                    }
                    this.chartData.noDataTips = '暂无相关成绩统计数据';
                    this.chartData.xAxisData = this.reportInfo.statisticsInfo.chartInfo.xAxisNames;
                    this.chartData.lineDatas = this.reportInfo.statisticsInfo.chartInfo.lineDatas;
                    this.chartTimestamp = new Date().getTime();
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            handleExamTypeChange(value){
                if(value === ''){
                    this.reportInfo.examTypeName = '';
                }else{
                    for(let i=0; i<this.comboOption.examType.length; i++){
                        if(this.comboOption.examType[i].comboValue === value){
                            this.reportInfo.examTypeName = this.comboOption.examType[i].comboName;
                            break;
                        }
                    }
                }
            },
            saveRec() {
                if(this.reportInfo.examTypeCode==null || this.reportInfo.examTypeCode==''){
                    this.$alert('请选择考试形式', '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }
                if(this.reportInfo.examDate==null || this.reportInfo.examDate==''){
                    this.$alert('请选择考试日期', '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }
                if(this.reportInfo.improveMeasure==null || this.reportInfo.improveMeasure==''){
                    this.$alert('请填写改进措施', '提示', {
                        confirmButtonText: '确定'
                    });
                    return;
                }

                this.$api.scoreManage.statistics.examQualityAnalysis.save({
                    data: this.reportInfo,
                }).then((res) => {
                    console.log(res.data.data);
                    if (res.data.data.state == 'Success') {
                        showNotify('成功', '保存成功', 'success', 1500);
                    }else{
                        showNotify('失败', '保存失败', 'error', 3000);
                    }
                }).catch((err) => {
                    showNotify('错误', err, 'error', 3000);
                });
            },
            exportInfo(){
                //跳过加载动画
                this.$refs['simpleLineChart'].drawLine(true);

                //获取折线图数据
                if(this.reportInfo.chartImgData == null){
                    this.reportInfo.chartImgData = this.$refs['simpleLineChart'].getChartImgData();
                }

                this.showLoadingMask("试卷质量分析表导出中，请稍候...");

                this.$api.scoreManage.statistics.examQualityAnalysis.export({
                    responseType: "blob",
                    data: this.reportInfo
                }).then((res) => {
                    const _this = this;
                    const resultData = res.data;

                    const fileReader = new FileReader();
                    fileReader.onload = function() {
                       if (resultData.type == 'application/json') {
                           const jsonData = JSON.parse(fileReader.result); // 说明是普通对象数据，后台转换失败
                           showNotify('错误', jsonData.msg, 'error', 3000);
                       } else {
                           const fileName = decodeURI(res.headers['content-disposition'].split('fileName=')[1]);
                           _this.downloadFile(resultData, fileName);
                       }
                    };
                    fileReader.readAsText(resultData);
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            printInfo(){
                //跳过加载动画
                this.$refs['simpleLineChart'].drawLine(true);

                //获取折线图数据
                if(this.reportInfo.chartImgData == null){
                    this.reportInfo.chartImgData = this.$refs['simpleLineChart'].getChartImgData();
                }
                this.showLoadingMask("试卷质量分析表打印处理中，请稍候...");

                this.$api.scoreManage.statistics.examQualityAnalysis.print({
                    data: this.reportInfo
                }).then((res) => {
                    if (res.data.data.state == "Success") {
                        let win = window.open(" ");
                        win.document.write(res.data.data.htmlStr);
                        win.document.close();
                        this.$nextTick(() => {
                           win.print();
                           win.close();
                        });
                    }else{
                        showNotify('错误', res.data.data.msg, 'error', 3000);
                    }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
            downloadFile(data, fileName) {
                let blob = new Blob([data], {type: "application/ms-excel;charset=utf-8"});

                //浏览器兼容，Google和火狐支持a标签的download，IE不支持
                if (window.navigator && window.navigator.msSaveBlob) {
                    window.navigator.msSaveBlob(blob, fileName);
                } else {
                    let url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(url);
                }
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            closeLoadingMask() {
                if(this.loadingMask) this.loadingMask.close();
            },
        },
    }
</script>
<style scoped>
    .custom-container {
        padding: 20px 0 20px 20px;
    }

    .reportInfo {
        overflow: auto;
    }

    .reportInfoTable {
        border-collapse: collapse;
    }

    .reportInfoTable tr {
        height: 30px;
    }

    .reportInfoTable td {
        padding-left: 10px;
        font-size: 14px;
    }

    .reportInfoTable .tableBorder {
        border: 1px solid #000000;
    }

    .reportInfoTable .tableTitle {
        height: 50px;
    }

    .reportInfoTable .tableTitle td {
        font-size: 18px;
        font-weight: bold;
    }

    .reportInfoTable .textCenter {
        padding: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// examQualityAnalysis.vue?ae9af688